import React from 'react';
import Box from 'ui-box';
import ControlledOptionsFieldArray from '../form-helpers/ControlledOptionsFieldArray';

const MobileSelectQuestion = ({isMultiSelect, ...restControlledOptionsFieldArrayProps}) => {
  return (
    <>
      <Box style={{ padding: 0, marginTop: 24 }}>
        <ControlledOptionsFieldArray isMultiSelect={isMultiSelect} {...restControlledOptionsFieldArrayProps} />
      </Box>
    </>
  );
}

export default MobileSelectQuestion;
